var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"back-button",attrs:{"aria-label":_vm.$t('common.bck')},on:{"click":function($event){return _vm.goBack(_vm.returnUrl)}}},[_c('i',{staticClass:"fa-solid fa-arrow-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }